import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import logoPng from "@/logo.png";

interface AuthShellProps {
	children: ReactNode;
	logoHref?: string;
	maxWidthClass?: string;
	contentClassName?: string;
	className?: string;
}

export function AuthShell({
	children,
	logoHref = "/",
	maxWidthClass = "max-w-sm",
	contentClassName,
	className,
}: AuthShellProps) {
	return (
		<div className={cn("min-h-dvh bg-gradient-subtle p-6 md:p-10", className)}>
			<div className="flex min-h-[calc(100dvh-theme(spacing.12))] items-center justify-center">
				<div className={cn("w-full", maxWidthClass)}>
					<div className="flex flex-col gap-6">
						<div className="flex justify-center">
							<Link to={logoHref as never} aria-label="Go to home">
								<img src={logoPng} alt="m8tes.ai" className="h-20 w-auto dark:invert" />
							</Link>
						</div>

						<div
							className={cn(
								"surface-glass-strong surface-divider flex flex-col gap-6 rounded-xl border p-6 md:p-8",
								contentClassName
							)}
						>
							{children}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
